export default __webpack_public_path__ + "c967a94cfbe2b06627ffe7861c741a61.woff2";